export default __webpack_public_path__ + "static/media/whatsapp_black_icon.c920c889.png";